import type { Product, Store, Deal, Coupon } from "@/types";

export const MOCK_STORES: Store[] = [
  { id: "walmart", slug: "walmart", name: "Walmart", logo: "/stores/walmart.svg", website: "https://walmart.com.mx", country: "MX", category: "SUPERMARKET", cashbackRate: 2.5, isFeatured: true },
  { id: "amazon", slug: "amazon", name: "Amazon México", logo: "/stores/amazon.svg", website: "https://amazon.com.mx", country: "MX", category: "MARKETPLACE", cashbackRate: 3, isFeatured: true },
  { id: "mercadolibre", slug: "mercadolibre", name: "Mercado Libre", logo: "/stores/mercadolibre.svg", website: "https://mercadolibre.com.mx", country: "MX", category: "MARKETPLACE", cashbackRate: 2, isFeatured: true },
  { id: "liverpool", slug: "liverpool", name: "Liverpool", logo: "/stores/liverpool.svg", website: "https://liverpool.com.mx", country: "MX", category: "RETAIL", cashbackRate: 3.5, isFeatured: true },
  { id: "chedraui", slug: "chedraui", name: "Chedraui", logo: "/stores/chedraui.svg", website: "https://chedraui.com.mx", country: "MX", category: "SUPERMARKET", cashbackRate: 1.5 },
  { id: "soriana", slug: "soriana", name: "Soriana", logo: "/stores/soriana.svg", website: "https://soriana.com", country: "MX", category: "SUPERMARKET", cashbackRate: 1.5 },
  { id: "sams", slug: "sams", name: "Sam's Club", logo: "/stores/sams.svg", website: "https://sams.com.mx", country: "MX", category: "WHOLESALE", cashbackRate: 2 },
  { id: "costco", slug: "costco", name: "Costco", logo: "/stores/costco.svg", website: "https://costco.com.mx", country: "MX", category: "WHOLESALE", cashbackRate: 1 },
  { id: "farma-guadalajara", slug: "farmacias-guadalajara", name: "Farmacias Guadalajara", logo: "/stores/farma-gdl.svg", website: "https://farmaciasguadalajara.com", country: "MX", category: "PHARMACY", cashbackRate: 2 },
  { id: "farma-ahorro", slug: "farmacias-del-ahorro", name: "Farmacias del Ahorro", logo: "/stores/farma-ahorro.svg", website: "https://fahorro.com", country: "MX", category: "PHARMACY", cashbackRate: 1.5 },
];

export const MOCK_PRODUCTS: Product[] = [
  {
    id: "p1",
    numericId: 1,
    globalProductId: "gp-leche-lala-entera-1l",
    categoryNumericId: 10,
    categorySlug: "lacteos",
    subcategory: "Leches",
    subcategorySlug: "leches",
    sku: "LALA-001",
    name: "Leche Entera LALA 1L",
    brand: "LALA",
    description: "Leche entera pasteurizada, fuente de calcio y vitaminas. Presentación de 1 litro.",
    imageUrl: "https://images.unsplash.com/photo-1563636619-e9143da7973b?w=400",
    category: "Lácteos",
    presentation: "1 Litro",
    weight: 1,
    weightUnit: "L",
    country: "MX",
    lowestPrice: 18.5,
    highestPrice: 25.0,
    avgPrice: 21.2,
    currency: "MXN",
    storeCount: 6,
    prices: [
      { storeId: "walmart", storeName: "Walmart", price: 18.5, originalPrice: 22.0, discount: 16, currency: "MXN", url: "https://walmart.com.mx/leche-lala", inStock: true, lastChecked: "2026-04-21T10:00:00Z" },
      { storeId: "chedraui", storeName: "Chedraui", price: 19.9, currency: "MXN", url: "https://chedraui.com.mx/leche-lala", inStock: true, lastChecked: "2026-04-21T09:00:00Z" },
      { storeId: "soriana", storeName: "Soriana", price: 21.5, currency: "MXN", url: "https://soriana.com/leche-lala", inStock: true, lastChecked: "2026-04-21T08:00:00Z" },
      { storeId: "amazon", storeName: "Amazon México", price: 23.0, currency: "MXN", url: "https://amazon.com.mx/leche-lala", inStock: false, lastChecked: "2026-04-21T07:00:00Z", shipping: "Gratis con Prime" },
    ],
    updatedAt: "2026-04-21T10:00:00Z",
  },
  {
    id: "p2",
    numericId: 2,
    globalProductId: "gp-iphone-15-128gb",
    categoryNumericId: 20,
    categorySlug: "celulares",
    subcategory: "Smartphones",
    subcategorySlug: "smartphones",
    sku: "APPL-IP15-128",
    name: "iPhone 15 128GB",
    brand: "Apple",
    description: "iPhone 15 con chip A16 Bionic, sistema de doble cámara de 48 MP y pantalla Super Retina XDR de 6.1 pulgadas.",
    imageUrl: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=400",
    category: "Celulares",
    country: "MX",
    lowestPrice: 17499,
    highestPrice: 20999,
    avgPrice: 18800,
    currency: "MXN",
    storeCount: 4,
    prices: [
      { storeId: "walmart", storeName: "Walmart", price: 17499, originalPrice: 19999, discount: 12, currency: "MXN", url: "https://walmart.com.mx/iphone15", inStock: true, lastChecked: "2026-04-21T10:00:00Z" },
      { storeId: "liverpool", storeName: "Liverpool", price: 18999, currency: "MXN", url: "https://liverpool.com.mx/iphone15", inStock: true, lastChecked: "2026-04-21T09:00:00Z" },
      { storeId: "amazon", storeName: "Amazon México", price: 18500, originalPrice: 19999, currency: "MXN", url: "https://amazon.com.mx/iphone15", inStock: true, lastChecked: "2026-04-21T08:00:00Z", shipping: "Gratis con Prime" },
      { storeId: "mercadolibre", storeName: "Mercado Libre", price: 17800, currency: "MXN", url: "https://mercadolibre.com.mx/iphone15", inStock: true, lastChecked: "2026-04-21T07:00:00Z" },
    ],
    updatedAt: "2026-04-21T10:00:00Z",
  },
  {
    id: "p3",
    numericId: 3,
    globalProductId: "gp-televisor-samsung-55-4k",
    categoryNumericId: 30,
    categorySlug: "electronica",
    subcategory: "Televisores",
    subcategorySlug: "televisores",
    sku: "SAMS-TV55-4K",
    name: "Smart TV Samsung 55\" 4K UHD",
    brand: "Samsung",
    description: "Televisor QLED 4K con resolución Crystal y procesador Crystal 4K. Panel de 55 pulgadas con HDR10+.",
    imageUrl: "https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?w=400",
    category: "Electrónica",
    country: "MX",
    lowestPrice: 8999,
    highestPrice: 12500,
    avgPrice: 10200,
    currency: "MXN",
    storeCount: 5,
    prices: [
      { storeId: "costco", storeName: "Costco", price: 8999, originalPrice: 11999, discount: 25, currency: "MXN", url: "https://costco.com.mx/tv-samsung", inStock: true, lastChecked: "2026-04-21T10:00:00Z" },
      { storeId: "walmart", storeName: "Walmart", price: 9499, currency: "MXN", url: "https://walmart.com.mx/tv-samsung", inStock: true, lastChecked: "2026-04-21T09:00:00Z" },
      { storeId: "liverpool", storeName: "Liverpool", price: 10999, originalPrice: 12500, discount: 12, currency: "MXN", url: "https://liverpool.com.mx/tv-samsung", inStock: true, lastChecked: "2026-04-21T08:00:00Z" },
      { storeId: "amazon", storeName: "Amazon México", price: 9899, currency: "MXN", url: "https://amazon.com.mx/tv-samsung", inStock: false, lastChecked: "2026-04-21T07:00:00Z" },
    ],
    updatedAt: "2026-04-21T10:00:00Z",
  },
  {
    id: "p4",
    numericId: 4,
    globalProductId: "gp-crema-olay-regenerist",
    categoryNumericId: 40,
    categorySlug: "belleza",
    subcategory: "Cuidado facial",
    subcategorySlug: "cuidado-facial",
    sku: "OLAY-RGN24",
    name: "Crema Olay Regenerist Retinol24",
    brand: "Olay",
    description: "Crema facial con retinol y niacinamida para reducir líneas de expresión y manchas. 50g.",
    imageUrl: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=400",
    category: "Belleza",
    presentation: "50g",
    country: "MX",
    lowestPrice: 289,
    highestPrice: 399,
    avgPrice: 340,
    currency: "MXN",
    storeCount: 5,
    prices: [
      { storeId: "farma-ahorro", storeName: "Farmacias del Ahorro", price: 289, originalPrice: 349, discount: 17, currency: "MXN", url: "https://fahorro.com/olay-regenerist", inStock: true, lastChecked: "2026-04-21T10:00:00Z" },
      { storeId: "walmart", storeName: "Walmart", price: 319, currency: "MXN", url: "https://walmart.com.mx/olay-regenerist", inStock: true, lastChecked: "2026-04-21T09:00:00Z" },
      { storeId: "amazon", storeName: "Amazon México", price: 299, currency: "MXN", url: "https://amazon.com.mx/olay-regenerist", inStock: true, lastChecked: "2026-04-21T08:00:00Z", shipping: "Gratis con Prime" },
    ],
    updatedAt: "2026-04-21T10:00:00Z",
  },
  {
    id: "p5",
    numericId: 5,
    globalProductId: "gp-aspirina-500mg-20tab",
    categoryNumericId: 50,
    categorySlug: "medicamentos",
    subcategory: "Analgésicos",
    subcategorySlug: "analgesicos",
    sku: "BAYER-ASP500",
    name: "Aspirina 500mg 20 tabletas",
    brand: "Bayer",
    description: "Ácido acetilsalicílico 500mg. Analgésico y antipirético. Caja de 20 tabletas.",
    imageUrl: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400",
    category: "Medicamentos",
    presentation: "20 tabletas",
    country: "MX",
    lowestPrice: 42,
    highestPrice: 68,
    avgPrice: 54,
    currency: "MXN",
    storeCount: 4,
    prices: [
      { storeId: "farma-guadalajara", storeName: "Farmacias Guadalajara", price: 42, currency: "MXN", url: "https://farmaciasguadalajara.com/aspirina", inStock: true, lastChecked: "2026-04-21T10:00:00Z" },
      { storeId: "farma-ahorro", storeName: "Farmacias del Ahorro", price: 45, currency: "MXN", url: "https://fahorro.com/aspirina", inStock: true, lastChecked: "2026-04-21T09:00:00Z" },
      { storeId: "walmart", storeName: "Walmart", price: 52, currency: "MXN", url: "https://walmart.com.mx/aspirina", inStock: true, lastChecked: "2026-04-21T08:00:00Z" },
    ],
    updatedAt: "2026-04-21T10:00:00Z",
  },
  {
    id: "p6",
    numericId: 6,
    globalProductId: "gp-laptop-hp-15-i5",
    categoryNumericId: 60,
    categorySlug: "computacion",
    subcategory: "Laptops",
    subcategorySlug: "laptops",
    sku: "HP-15-I5",
    name: "Laptop HP 15\" Intel Core i5",
    brand: "HP",
    description: "Laptop HP con procesador Intel Core i5-1235U, 8GB RAM, 512GB SSD, pantalla FHD 15.6\".",
    imageUrl: "https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=400",
    category: "Computación",
    country: "MX",
    lowestPrice: 11499,
    highestPrice: 14999,
    avgPrice: 12800,
    currency: "MXN",
    storeCount: 4,
    prices: [
      { storeId: "sams", storeName: "Sam's Club", price: 11499, originalPrice: 13999, discount: 18, currency: "MXN", url: "https://sams.com.mx/laptop-hp", inStock: true, lastChecked: "2026-04-21T10:00:00Z" },
      { storeId: "walmart", storeName: "Walmart", price: 12499, currency: "MXN", url: "https://walmart.com.mx/laptop-hp", inStock: true, lastChecked: "2026-04-21T09:00:00Z" },
      { storeId: "amazon", storeName: "Amazon México", price: 11999, currency: "MXN", url: "https://amazon.com.mx/laptop-hp", inStock: true, lastChecked: "2026-04-21T08:00:00Z", shipping: "Gratis con Prime" },
    ],
    updatedAt: "2026-04-21T10:00:00Z",
  },
];

export const MOCK_COUPONS: Coupon[] = [
  {
    id: "c1",
    storeId: "walmart",
    storeName: "Walmart",
    code: "WALMART20",
    title: "20% de descuento en electrónica",
    description: "Válido en todos los productos electrónicos seleccionados.",
    type: "CODE",
    discount: 20,
    discountType: "PERCENTAGE",
    minPurchase: 500,
    maxDiscount: 800,
    successRate: 87,
    useCount: 2341,
    expiresAt: "2026-04-30T23:59:59Z",
    isVerified: true,
    isExclusive: false,
  },
  {
    id: "c2",
    storeId: "amazon",
    storeName: "Amazon México",
    code: "PRIME15",
    title: "15% adicional para miembros Prime",
    description: "Exclusivo para miembros Amazon Prime. Aplica en miles de productos.",
    type: "CODE",
    discount: 15,
    discountType: "PERCENTAGE",
    minPurchase: 300,
    successRate: 72,
    useCount: 5678,
    expiresAt: "2026-05-15T23:59:59Z",
    isVerified: true,
    isExclusive: true,
  },
  {
    id: "c3",
    storeId: "liverpool",
    storeName: "Liverpool",
    title: "Envío gratis en compras +$699",
    description: "Sin código necesario. Aplica automáticamente en tu carrito.",
    type: "FREE_SHIPPING",
    minPurchase: 699,
    successRate: 95,
    useCount: 8920,
    isVerified: true,
    isExclusive: false,
  },
  {
    id: "c4",
    storeId: "mercadolibre",
    storeName: "Mercado Libre",
    code: "MELI500",
    title: "$500 de descuento en tu primera compra +$2000",
    description: "Solo para nuevos usuarios. Compra mínima de $2,000 pesos.",
    type: "CODE",
    discount: 500,
    discountType: "FIXED",
    minPurchase: 2000,
    successRate: 68,
    useCount: 1234,
    expiresAt: "2026-06-01T23:59:59Z",
    isVerified: false,
    isExclusive: false,
  },
  {
    id: "c5",
    storeId: "farma-guadalajara",
    storeName: "Farmacias Guadalajara",
    code: "SALUD10",
    title: "10% en medicamentos sin receta",
    description: "Aplica en toda la línea de medicamentos de libre venta.",
    type: "CODE",
    discount: 10,
    discountType: "PERCENTAGE",
    successRate: 91,
    useCount: 3456,
    expiresAt: "2026-05-01T23:59:59Z",
    isVerified: true,
    isExclusive: false,
  },
];

export const MOCK_DEALS: Deal[] = [
  {
    id: "d1",
    userId: "u1",
    userName: "AhorroMaster",
    userLevel: "GOLD",
    storeId: "amazon",
    storeName: "Amazon México",
    title: "🔥 PlayStation 5 Slim a $8,999 (precio histórico mínimo)",
    description: "Amazon tiene el PS5 Slim al precio más bajo que he visto. Incluye el DualSense. Precio normal es $11,999. Esta oferta terminó hace 2 semanas y acaba de volver.",
    price: 8999,
    originalPrice: 11999,
    discount: 25,
    imageUrl: "https://images.unsplash.com/photo-1606813907291-d86efa9b94db?w=600",
    productUrl: "https://amazon.com.mx/ps5",
    temperature: 847,
    voteCount: 1205,
    commentCount: 89,
    viewCount: 45200,
    isExpired: false,
    isFeatured: true,
    category: "Electrónica",
    tags: ["gaming", "playstation", "consola"],
    expiresAt: "2026-04-25T23:59:59Z",
    createdAt: "2026-04-21T08:30:00Z",
  },
  {
    id: "d2",
    userId: "u2",
    userName: "Bargain_Hunter",
    userLevel: "PLATINUM",
    storeId: "costco",
    storeName: "Costco",
    title: "Colchón King Size Sealy + envío gratis a $6,499",
    description: "El Sealy Posturepedic King Size está en Costco a precio increíble. Lo compré hace 3 días y ya llegó. Gran calidad y envío gratis incluido. Sin costo de membresía si pides online.",
    price: 6499,
    originalPrice: 9999,
    discount: 35,
    imageUrl: "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=600",
    productUrl: "https://costco.com.mx/colchon-sealy",
    temperature: 312,
    voteCount: 445,
    commentCount: 32,
    viewCount: 12800,
    isExpired: false,
    category: "Hogar",
    tags: ["colchon", "bedroom", "hogar"],
    createdAt: "2026-04-21T06:15:00Z",
  },
  {
    id: "d3",
    userId: "u3",
    userName: "TechDeals_MX",
    userLevel: "DIAMOND",
    storeId: "walmart",
    storeName: "Walmart",
    title: "AirPods Pro 2da Gen a $3,499 (mínimo histórico)",
    description: "Los AirPods Pro segunda generación con cancelación activa de ruido están a precio mínimo en Walmart online. Normalmente cuestan $4,999. Aplica código APPLE en caja.",
    price: 3499,
    originalPrice: 4999,
    discount: 30,
    imageUrl: "https://images.unsplash.com/photo-1600294037681-c80b4cb5b434?w=600",
    productUrl: "https://walmart.com.mx/airpods-pro",
    temperature: 623,
    voteCount: 892,
    commentCount: 67,
    viewCount: 31500,
    isExpired: false,
    category: "Electrónica",
    tags: ["apple", "airpods", "audio"],
    createdAt: "2026-04-20T22:00:00Z",
  },
  {
    id: "d4",
    userId: "u4",
    userName: "FoodieOffers",
    userLevel: "SILVER",
    storeId: "sams",
    storeName: "Sam's Club",
    title: "Canasta básica 50 productos $450 (ahorro de $200)",
    description: "Sam's Club tiene combo especial de 50 productos básicos. Incluye aceite, arroz, frijol, azúcar, leche, jabón, etc. Perfecto para llevar la despensa al mes.",
    price: 450,
    originalPrice: 650,
    discount: 31,
    imageUrl: "https://images.unsplash.com/photo-1542838132-92c53300491e?w=600",
    productUrl: "https://sams.com.mx/canasta-basica",
    temperature: 156,
    voteCount: 223,
    commentCount: 18,
    viewCount: 8900,
    isExpired: false,
    category: "Supermercado",
    tags: ["despensa", "ahorro", "basicos"],
    createdAt: "2026-04-20T15:30:00Z",
  },
  {
    id: "d5",
    userId: "u5",
    userName: "PharmaSaver",
    userLevel: "GOLD",
    storeId: "farma-ahorro",
    storeName: "Farmacias del Ahorro",
    title: "Vitamina D3 + C combo 60 tabletas a $89 (3x1)",
    description: "Promo 3x1 en vitaminas seleccionadas. Puedes combinar Vitamina C 500mg, Vitamina D3 1000UI, y Zinc. Todas de 60 tabletas. Disponible en sucursales físicas.",
    price: 89,
    originalPrice: 267,
    discount: 67,
    imageUrl: "https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=600",
    productUrl: "https://fahorro.com/vitaminas-promo",
    temperature: 489,
    voteCount: 678,
    commentCount: 45,
    viewCount: 21000,
    isExpired: false,
    category: "Farmacia",
    tags: ["vitaminas", "salud", "farmacia"],
    createdAt: "2026-04-20T10:00:00Z",
  },
];
